module.exports = __webpack_public_path__ + "static/accounting_details-57bcbc87af1a4381423054aa4027b494.png";